import jsPDF from "jspdf";
import "jspdf-autotable";

const generatePDF = (tableRows, isLandscape, title) => {
  const doc = new jsPDF({
    orientation: isLandscape ? "landscape" : "portrait",
  });

  // Set the date on the top left
  const currentDate = new Date().toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
 
 
  doc.setFontSize(10);
  doc.text(currentDate, 14, 10); // Date aligned to the top left corner

  // Add title in the center
  doc.setFontSize(14);
  const pageWidth = doc.internal.pageSize.getWidth(); // Get page width for centering
  const textWidth = doc.getTextWidth(title);
  doc.text(title, (pageWidth - textWidth) / 2, 10); // Title centered

  // Prepare table data
  const rows = tableRows.map((row) => [row.label, row.value]);

  // Generate the table using autoTable
  doc.autoTable({
    body: rows, // Table data
    startY: 20, // Start the table after the title and date
    styles: {
      fontSize: 10,
      cellPadding: 3,
      lineColor: [0, 0, 0],
      lineWidth: 0.5,
      halign: "left",
    },
    columnStyles: {
      0: { fontStyle: "bold", cellWidth: 60 ,textColor:['black']}, // First column (Label) bold and width adjustment
      1: { cellWidth: 100 ,textColor:['black'],}, // Second column (Value) width adjustment
    },
    theme: "grid",
  });

  // Save the PDF
  doc.save(title + ".pdf");
};

export default generatePDF;
